export default "__VITE_ASSET__CZn2vKno__"